import React, { useEffect, useState } from "react";
import { timeAgo } from "../../utils/common";
import PageHeading from "../pageHeading/PageHeading";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useSelector, useDispatch } from "react-redux";
import { selectUser } from "../../slice/authSlice";
import { setLoader } from "../../slice/commonSlice";
import { fetchNotification } from "../../services/auth.service";
import "./notificationList.scss";
import Paginate from "../paginate/Paginate";

const NotificationList = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [totalPages, setTotalPages] = useState(10);
  const [notification, setNotification] = useState(null);
  const [page, setPage] = useState(1);
  useEffect(() => {
    if (user) {
      getNotification();
    }
  }, []);

  const getNotification = async (currentpage) => {
    let payload = {
      id: user?.id,
      userType: user?.userType,
      limit: 10,
      page: currentpage || 1,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchNotification(payload);
      await dispatch(setLoader(false));
      if (response.data.status) {
        setNotification(response.data.notifications);
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };
  const handlePageChange = (page) => {
    setPage(page);
    getNotification(page);
  };
  return (
    <>
      <Header />
      <PageHeading title="Notifications" />
      <div className="main-container">
        <div className="notification-list-wrapper">
          {notification?.length > 0 ? (
            <>
              {notification?.map((item, index) => (
                <div className="notification-list-row" key={index}>
                  <div className="notification-list-detail-wrap">
                    <div className="notification-list-user-wrap">
                      <div className="notification-list-user-detail">
                        <div className="notification-list-user-name-wrap">
                          {item?.title}
                        </div>
                        <div className="notification-list-date">
                          {timeAgo(item?.createdAt)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="notification-list-description">
                    {item?.message}
                  </div>
                </div>
              ))}
              <Paginate
                totalPages={totalPages}
                currentPage={page}
                onPageChange={handlePageChange}
              />
            </>
          ) : (
            <p>You have no notification</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotificationList;
